import { render } from "./SleepCalculator.vue?vue&type=template&id=83fd6842"
import script from "./SleepCalculator.vue?vue&type=script&lang=js"
export * from "./SleepCalculator.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__